require('./brokerHireDerivativesAccountStep1.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const Immutable = require('immutable');

// @components
const WizardStep = require('components/commons/wizardStep/wizardStep');
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

// @constants
const {
    FIRST_STEP,
    BROKER_STOCKS_CONTRACT_DROPDOWN_ASSOCIATED_ACCOUNT_MODIFIER
} = require('constants/index');

const CLASS_NAME = 'broker-hire-derivatives-account-step1';

class BrokerHireDerivativesAccountStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.handleSelectAssociatedAccount = this.handleSelectAssociatedAccount.bind(this);
        this.buildHeader = this.buildHeader.bind(this);
        this.buildAssociatedAccount = this.buildAssociatedAccount.bind(this);
        this.buildInterveners = this.buildInterveners.bind(this);
    }

    componentDidMount() {
        this.props.fetchAssociatedAccounts();
    }

    buildAssociatedAccount() {
        const { immBrokerHireDerivativesAccount, immBrokerWallets } = this.props;
        let content;

        if (immBrokerHireDerivativesAccount.get('fetchingContracts')) {
            content = <LoadingSection/>;
        } else {
            const selectedAssociatedContract = immBrokerHireDerivativesAccount.getIn(
                ['steps', FIRST_STEP, 'selectedAssociatedContract']
            );

            const immOptions = immBrokerHireDerivativesAccount.get('contracts').map((immContract, index) => {
                const immOwner = immBrokerWallets.get('allFuturesList').find(
                    immFutures => immFutures.getIn(['cviejo', 'numerodecontrato']) == immContract.get('contractNumber')
                ) || Immutable.fromJS({});

                return {
                    value: index,
                    firstOwner: immOwner.get('nombretitular', '').trim(),
                    firstOwnerType: immOwner.getIn(['descIntervenciones', 'nomTipInterv'], '').trim(),
                    walletAccountType: immContract.get('accountType'),
                    walletNumber: immContract.get('contractNumber'),
                    walletBalance: {
                        amount: immContract.get('balance'),
                        currency: immContract.get('currency')
                    },
                };
            });

            content = (
                <StocksContractDropdown
                    label="hireDerivativesAccount-associatedAccountLabel"
                    onStockContractChange={this.handleSelectAssociatedAccount}
                    options={immOptions.toJS()}
                    selectedValue={selectedAssociatedContract}
                    modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_ASSOCIATED_ACCOUNT_MODIFIER}
                />
            );
        }

        return (
            <div className={`${CLASS_NAME}__field`}>
                {content}
            </div>
        );
    }

    buildHeader() {
        return (
            <section>
                <h4 className={`${CLASS_NAME}__header-title`}>
                    <FormattedText
                        value="hireDerivativesAccount-hireData"
                    />
                </h4>
                <div className={`${CLASS_NAME}__info`}>
                    <FormattedText
                        value="hireDerivativesAccount-associatedAccount"
                    />
                </div>
            </section>
        );
    }

    buildInterveners() {
        const { immBrokerHireDerivativesAccount, onRemoveIntervener } = this.props;
        const selectedContractIndex = immBrokerHireDerivativesAccount.getIn(['steps', FIRST_STEP, 'selectedAssociatedContract']);
        const immSelectedContract = immBrokerHireDerivativesAccount.getIn(['contracts', selectedContractIndex]);
        const immInterveners = immBrokerHireDerivativesAccount.getIn(['interveners', immSelectedContract.get('contractNumber')]);
        const immSelectedInterveners = immBrokerHireDerivativesAccount.getIn(['steps', FIRST_STEP, 'interveners']);
        const immNotSelectedOptions = immInterveners.filter(immIntervener => !immSelectedContract.contains(immIntervener));

        const immAssociatedAccountSelectOptions = immNotSelectedOptions.map(immIntervener => {
            return {
                value: immIntervener.get('name'),
                label: immIntervener.get('name')
            };
        });

        const immTypeSelectOptions = immNotSelectedOptions.map(immIntervener => {
            return {
                value: immIntervener.get('type'),
                label: immIntervener.get('type'),
            };
        });
        const multipleSelectedInverveners = immSelectedInterveners.size > 1;

        const interveners = immSelectedInterveners.map((immIntervener, index) => {
            const removeOption = this.buildRemoveButton(multipleSelectedInverveners, index, onRemoveIntervener);

            return (
                <div className={`row ${CLASS_NAME}__field`} key={index}>
                    <div className="col-xs-5">
                        <OKSelect
                            label="hireDerivativesAccount-name"
                            options={immAssociatedAccountSelectOptions.toJS()}
                            value={immIntervener.get('name')}
                        />
                    </div>
                    <div className="col-xs-5">
                        <OKSelect
                            label="hireDerivativesAccount-interventionType"
                            options={immTypeSelectOptions.toJS()}
                            value={immIntervener.get('type')}
                        />
                    </div>
                    {removeOption}
                </div>
            );
        });

        const multipleInverveners = immInterveners && immInterveners.size > 1;
        let intervenersOperations = this.buildIntervenersOperations(multipleInverveners);

        return (
            <section>
                <div className={`${CLASS_NAME}__info`}>
                    <FormattedText
                        value="hireDerivativesAccount-contractInterveners"
                    />
                </div>
                <div className={`${CLASS_NAME}__field`}>
                    {interveners}
                </div>
                {intervenersOperations}
            </section>
        );
    }

    buildIntervenersOperations(multipleInverveners) {
        const { onAddIntervener, onResetInterveners } = this.props;
        if (multipleInverveners) {
            return (<div className={`${CLASS_NAME}__field`}>
                <OKButton modifier="link-complementary" onClick={onAddIntervener}>
                    <FormattedText value="hireDerivativesAccount-addIntervener" />
                </OKButton>
                <span className={`${CLASS_NAME}__separator`}>|</span>
                <OKButton modifier="link-complementary" onClick={onResetInterveners}>
                    <FormattedText value="hireDerivativesAccount-resetInterveners" />
                </OKButton>
            </div>);
        }
    }

    buildRemoveButton(multipleSelectedInverveners, index, onRemoveIntervener) {
        if (multipleSelectedInverveners) {
            return (<div className={`col-xs-2 ${CLASS_NAME}__remove-intervenier`}>
                <div
                    className={`${CLASS_NAME}__remove-intervenier-button`}
                    onClick={() => onRemoveIntervener(index)}
                >X</div>
            </div>)
        }
    }

    /**
     *
     * @param {number} index Index of the selected option
     */
    handleSelectAssociatedAccount(index) {
        const { immBrokerHireDerivativesAccount } = this.props;

        const contractNumber = immBrokerHireDerivativesAccount.getIn([
            'contracts', index, 'contractNumber'
        ]);
        const product = immBrokerHireDerivativesAccount.getIn([
            'contracts', index, 'product'
        ]);
        const balance = immBrokerHireDerivativesAccount.getIn([
            'contracts', index, 'balance'
        ]);

        this.props.onSelectAssociatedAccount(index);
        this.props.fetchDerivatives(contractNumber, product, balance);
    }

    render() {
        const { immBrokerHireDerivativesAccount, actions, cancelButton, nextButton } = this.props;
        const immFirstStep = immBrokerHireDerivativesAccount.getIn(['steps', FIRST_STEP]);
        const contractIsSelected = immFirstStep.get('selectedAssociatedContract') !== null;
        const fetchingInterveners = immBrokerHireDerivativesAccount.get('fetchingInterveners');
        let interveniers;

        if (contractIsSelected && fetchingInterveners) {
            interveniers = <LoadingSection/>;
        } else if (contractIsSelected && !fetchingInterveners) {
            interveniers = this.buildInterveners();
        }

        return (
            <WizardStep
                actions={actions}
                cancelButton={cancelButton}
                nextButton={nextButton}
                position="first"
            >
                {this.buildHeader()}
                {this.buildAssociatedAccount()}
                {interveniers}
            </WizardStep>
        );
    }
}

BrokerHireDerivativesAccountStep1.propTypes = {
    immBrokerHireDerivativesAccount: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    fetchAssociatedAccounts: PropTypes.func.isRequired,
    fetchDerivatives: PropTypes.func.isRequired,
    onAddIntervener: PropTypes.func.isRequired,
    onRemoveIntervener: PropTypes.func.isRequired,
    onResetInterveners: PropTypes.func.isRequired,
    onSelectAssociatedAccount: PropTypes.func.isRequired,
    cancelButton: PropTypes.bool,
    nextButton: PropTypes.bool
};

BrokerHireDerivativesAccountStep1.defaultProps = {
    cancelButton: true,
    nextButton: true
}

module.exports = BrokerHireDerivativesAccountStep1;